import React from 'react';
import styles from './ActivityHeader.module.scss';

const ActivityHeader = ({ selectedActivity, setSelectedActivity }) => {
  return (
    <div className={styles['row']}>
      <div className={styles['container']}>
        <div>
          <span
            className={
              null === selectedActivity ? styles['active'] : styles['in-active']
            }
            onClick={() => setSelectedActivity(null)}
          >
            الكل
          </span>
        </div>
        <div>
          <span
            className={
              true === selectedActivity ? styles['active'] : styles['in-active']
            }
            onClick={() => setSelectedActivity(true)}
          >
            نشط
          </span>
        </div>
        <div>
          <span
            className={
              false === selectedActivity
                ? styles['active']
                : styles['in-active']
            }
            onClick={() => setSelectedActivity(false)}
          >
            غير نشط
          </span>
        </div>
      </div>
    </div>
  );
};

export default ActivityHeader;
